var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInjection = function SvgInjection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.78992 0.805087L6.18908 2.27104L7.13446 1.40589L6.2521 0.516715L6.79412 0L9 2.27104L8.53362 2.73968L7.7269 1.98267L6.81933 2.82376L8.25631 4.34982L7.68907 4.92656L6.89496 4.15756C6.89496 4.15756 3.56723 7.42589 3.00001 7.96661C2.43278 8.50733 1.62605 7.96661 1.62605 7.96661L0.504204 9L0 8.75967L1.24791 7.60614C1.24791 7.60614 0.466388 6.68092 1.22269 5.95996C1.97899 5.239 4.94117 2.30709 4.94117 2.30709L4.15967 1.30977L4.78992 0.79306V0.805087Z",
    fill: "#1D1D1B"
  })));
};
export default SvgInjection;